import React from 'react';
import { Table } from 'react-bootstrap';

const TableWrapper = ({ 
  children, 
  className = "", 
  responsive = true, 
  ...props 
}) => {
  const tableClasses = [
    'align-items-center',
    'table-flush',
    'table-outlines'
  ];

  if (className) {
    tableClasses.push(className);
  }

  return (
    <div className="custom-scroll-wrapper">
      <div className="scroll-container">
        <Table 
          responsive={responsive} 
          className={tableClasses.join(' ')}
          {...props}
        >
          {children}
        </Table>
      </div>
    </div>
  );
};

export default TableWrapper; 